var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSheetDeleteSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.2,
    height: 14.994,
    viewBox: "0 0 13.2 14.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_76194",
    "data-name": "Group 76194",
    transform: "translate(-657.764 -237.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78554",
    "data-name": "Path 78554",
    d: "M2141.586,345.338a.122.122,0,0,0-.123.057,2.739,2.739,0,0,0-.288.536l-.013.029-.749,1.745h-2.582a.371.371,0,0,0-.371.37v1.012a.372.372,0,0,0,.371.372h.848l.623,8.785v.022a.634.634,0,0,0,.634.634h6.816a.634.634,0,0,0,.634-.634v-.044l.621-8.763h.848a.372.372,0,0,0,.371-.372v-1.012a.371.371,0,0,0-.371-.37h-2.58l-.745-1.754c-.244-.572-.322-.613-.42-.613h-3.526m0-.616h3.526c.545,0,.762.459.987.987l.586,1.379h2.172a.987.987,0,0,1,.988.987v1.012a.988.988,0,0,1-.988.988h-.273l-.581,8.19a1.25,1.25,0,0,1-1.25,1.25h-6.816a1.25,1.25,0,0,1-1.25-1.25l-.581-8.19h-.274a.988.988,0,0,1-.988-.988v-1.012a.987.987,0,0,1,.988-.987h2.176l.592-1.379C2140.855,345.154,2141.041,344.722,2141.586,344.722Z",
    transform: "translate(-1478.98 -106.722)",
    fill: "#f45e29",
    stroke: "#f45e29",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_75500",
    "data-name": "Group 75500",
    transform: "translate(662.686 244.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_863",
    "data-name": "Line 863",
    d: "M-.17,5.111A.321.321,0,0,1-.5,4.8V-.188A.321.321,0,0,1-.17-.5a.321.321,0,0,1,.33.312V4.8A.321.321,0,0,1-.17,5.111Z",
    transform: "translate(0.5 0.5)",
    fill: "#f45e29",
    stroke: "#f45e29",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_864",
    "data-name": "Line 864",
    d: "M-.17,5.111A.321.321,0,0,1-.5,4.8V-.188A.321.321,0,0,1-.17-.5a.321.321,0,0,1,.33.312V4.8A.321.321,0,0,1-.17,5.111Z",
    transform: "translate(3.138 0.5)",
    fill: "#f45e29",
    stroke: "#f45e29",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_78555",
    "data-name": "Path 78555",
    d: "M-182.534-15396.866h-9.941v-.659h9.941Z",
    transform: "translate(851.839 15640.252)",
    fill: "#f45e29",
    stroke: "#f45e29",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSheetDeleteSmall);
export default __webpack_public_path__ + "static/media/icon-sheet-delete-small.df685d39.svg";
export { ForwardRef as ReactComponent };